import { render, staticRenderFns } from "./FlowDynamicTable.vue?vue&type=template&id=a1b50f0c&"
import script from "./FlowDynamicTable.vue?vue&type=script&lang=js&"
export * from "./FlowDynamicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports